import { render, staticRenderFns } from "./InvitationView.vue?vue&type=template&id=b20c3374&scoped=true&"
import script from "./InvitationView.vue?vue&type=script&lang=ts&"
export * from "./InvitationView.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationView.vue?vue&type=style&index=0&id=b20c3374&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20c3374",
  null
  
)

export default component.exports